import React, { useEffect, useState } from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import clsx from "clsx";

import CheckCircleIcon from "../../assets/CheckCircleIcon";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'

import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import CardForm from '../ui/cardForm'
import { getMemberships } from '../../store/actions/membershipActions'
import { CircularProgress } from "@material-ui/core";
import { isJSDocNullableType } from "typescript";
import queryString from 'query-string'
import { useLocation } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
    root: {
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    icon: {
        borderRadius: "50%",
        width: 24,
        height: 24,
        border: '1px solid black'
    },
    checkedIcon: {
        color: "black",
        boxShadow: "none",
        border: 'none',
        width: 26,
        height: 26,
    },

}));

const styles = theme => ({
    loaderDiv: {
        padding: theme.spacing(3)
    },
    label: {
        fontWeight: 500,
        fontSize: theme.spacing(2.5)
    },
    marginTop3: {
        marginTop: theme.spacing(3)
    },
    subText: {
        color: theme.palette.text.primary
    },
    line: {
        borderTop: '1px solid #9193949e',

    },
    padding1half: {
        padding: theme.spacing(1.5)
    },
    blackBorderButton: {

        border: '1px solid black',
        color: 'black',
        '&:hover': {
            backgroundColor: 'transparent',
            border: '1px solid black '
        }
    },

})

function StyledRadio(props) {
    const classes = useStyles();

    return (
        <div>


            <Radio
                className={classes.root}
                disableRipple
                color="default"
                checkedIcon={
                    <CheckCircleIcon
                        className={clsx(classes.icon, classes.checkedIcon)}
                        fontSize="large"
                    />
                }
                icon={<span className={classes.icon} />}
                {...props}
            ></Radio>
        </div>
    );
}

const MembershipOptions = ({ classes, handleChange, defaultValueCb }) => {

    const dispatch = useDispatch()
    const location = useLocation()
    const params = queryString.parse(
        location.search
    );
    
    const [loading, setLoading] = useState(false)
    const membershipRegs = useSelector(state => state.memberships.regs)
    const [defaultReg, setDefaultReg] = useState(null)
    const [valueSelected, setValueSelected] = useState(null)
    const [regsToExclude, setRegsToExclude] = useState(['Golf Add-on Membership', 'Social Add-on Membership'])
    useEffect(() => {
        setLoading(true)
        dispatch(getMemberships(() => {
            setLoading(false)
        }))
    }, [])

    useEffect(() => {
        if (membershipRegs && membershipRegs.length > 0) {

            if(params.type === 'add-ons'){
                setRegsToExclude(['Full Golf Membership', 'Full Anytime Golf Membership', 'Social Membership'])
            }

            if (params.regId) {
                let selectedMembership = membershipRegs.find(item => item._id === params.regId);
                console.log(selectedMembership)
                setDefaultReg(selectedMembership._id + '|' + selectedMembership.registrationTitle)
                defaultValueCb(selectedMembership._id + '|' + selectedMembership.registrationTitle)

            } else {
                let indexToStart = 0;
                if(params.type === 'add-ons'){
                    indexToStart = 1;
                }
                console.log(indexToStart)
                console.log(membershipRegs)
                setDefaultReg(membershipRegs[indexToStart]._id + '|' + membershipRegs[indexToStart].registrationTitle)
                defaultValueCb(membershipRegs[indexToStart]._id + '|' + membershipRegs[indexToStart].registrationTitle)
            }

        }
    }, [membershipRegs])

    const handleOnChange = (e) => {

        setValueSelected(e.target.value)
        handleChange(e)
    }
    
    return <FormControl disabled={params.type === 'add-ons'} component="fieldset" style={{ width: "100%" }}>
        <RadioGroup
            aria-label="gender"
            name="gender1"
            value={valueSelected ? valueSelected : defaultReg}
            onChange={handleOnChange}
        >

            {
                loading && <Grid container item justify="center" className={classes.loaderDiv}><CircularProgress></CircularProgress></Grid>
            }
            {
                membershipRegs.map(reg => {
                    return !regsToExclude.includes(reg.registrationTitle) && <FormControlLabel
                        style={{ justifyContent: "flex-start", marginRight: 0 }}
                        labelPlacement="end"

                        className={classnames(classes.label)}
                        value={`${reg._id}|${reg.registrationTitle}`}
                        classes={{ label: classes.label }}
                        control={<StyledRadio amt="$150" />}
                        label={`${reg.registrationTitle} - $${reg.amountToRegister / 100}/${reg.billingInterval ? reg.billingInterval : 'month'}`}
                    />
                })
            }

            {/*<FormControlLabel
                style={{ justifyContent: "flex-start", marginRight: 0 }}
                labelPlacement="end"

                className={classnames(classes.label)}
                value="No membership"
                classes={{ label: classes.label }}
                control={<StyledRadio amt="$150" />}
                label="No Membership"
            />*/}

        </RadioGroup>

    </FormControl>

}

export default withStyles(styles)(MembershipOptions)